import { Component, OnInit, } from '@angular/core';
import {GranServicioDePTWService}from '../gran-servicio-de-ptw.service'
import { ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'
import { AlertController, ToastController,LoadingController,ModalController } from '@ionic/angular';
import {TimelineComponent} from '../timeline/timeline.component'
import { Router } from '@angular/router';
import {ModalHerramientasYControlesPage } from '../modal-herramientas-ycontroles/modal-herramientas-ycontroles.page'
import * as firebase from 'firebase'


@Component({
  selector: 'app-paso5page',
  templateUrl: './paso5page.page.html',
  styleUrls: ['./paso5page.page.scss'],
})
export class Paso5pagePage implements OnInit {

  arrayDeTrabajadores=[]

  arraydeIncompletos=[]
  arrayActividadesPTW=[]

  constructor(public granServicioDePTWService:GranServicioDePTWService,private router:Router, public modalController: ModalController, public timelineComponent:TimelineComponent, public servicioLoadersAlertasService:ServicioLoadersAlertasService ) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
    this.arrayActividadesPTW=[]
    this.timelineComponent.actualizar()
    this.recuperaArrayTrabajadores()
  }

  recuperaArrayTrabajadores(){
    
    this.granServicioDePTWService.cargadatosdePTW((respuesta)=>{
      this.arrayDeTrabajadores = respuesta.data().arrayDeEmpleados
      // this.arrayActividadesPTW = respuesta.data().arrayActividadesPTW

    
      //si el arrayActividadesPTW es indefinido, o sea que es de un ptw viejo anterior a esta actualizacion, creamos ese array de actividades a partir de la data existente en los trabajadores
      if(respuesta.data().arrayActividadesPTW != undefined){
        this.arrayActividadesPTW = respuesta.data().arrayActividadesPTW
      }else
      if(respuesta.data().arrayActividadesPTW == undefined){
        respuesta.data().arrayDeEmpleados.forEach(element => {
          this.desglosaActividadesDeTrabajadores(element.arraydeactividades)
        });
      }
      
    })    
  }

  desglosaActividadesDeTrabajadores(arrayActividadesTrabajador){
    arrayActividadesTrabajador.forEach(actividadTrabajador=>{
      //el some arroja true si hay un item en el array con el parámetro actividad igual
      if(this.arrayActividadesPTW.some((item)=>item.actividad == actividadTrabajador.actividad) == false){
         this.arrayActividadesPTW.push({actividad:actividadTrabajador.actividad, herramientasYcontroles:null})        
      }
    })
  }




 

  async  presentaActividad(actividad,indiceActividad) {
    const modal = await this.modalController.create({
      component: ModalHerramientasYControlesPage,
      cssClass: 'modalHerramientasYControles',
      componentProps: {
        'actividad': actividad,
        'indiceActividad':indiceActividad,
        // 'trabajador':item,
        // 'indiceTrabajador':i,
        'arrayActividadesPTW':this.arrayActividadesPTW
      },
      backdropDismiss:false
    
    });
    modal.onDidDismiss().then((data)=>{
      // alert(data.data.actividadActualizada)
    })
    return await modal.present();
  }

  // buscaActividadesSinDiligenciar(){
  //   let puedecontinuar = true
  //   this.arrayDeTrabajadores.forEach((trabajador,index)=>{
  //     trabajador.arraydeactividades.forEach((actividad)=>{
  //       if (actividad.herramientasYcontroles == undefined){
  //         if(index == this.arrayDeTrabajadores.length -1){
  //           puedecontinuar = false
  //           this.servicioLoadersAlertasService.alerta("Actividades sin diligenciar","Existen actividades sin diligenciar en el permiso de trabajo. Por favor diligencie todos para poder continuar.")
  //         }
  //       }
  //       if(index == this.arrayDeTrabajadores.length -1 && puedecontinuar == true){
  //         // this.timelineComponent.avanzar('5')
  //         firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
  //           arrayActividadesPTW:this.arrayActividadesPTW,
  //           "objetoPasosCompletados.paso5":"ok"
  //         })

  //         this.navegar("/paso6page")
  //       }
  //     })
  //   })
  // }

  buscaActividadesSinDiligenciar(){
    let puedecontinuar = true
    this.arrayActividadesPTW.forEach((item,index)=>{

      if(item.herramientasYcontroles == undefined){
        puedecontinuar = false
      }

      if(index == this.arrayActividadesPTW.length -1){

        if(puedecontinuar == true){
          firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
            arrayActividadesPTW:this.arrayActividadesPTW,
            "objetoPasosCompletados.paso5":"ok"
          })
          this.navegar("/paso6page")
        }else
        if(puedecontinuar == false){
            this.servicioLoadersAlertasService.alerta("Actividades sin diligenciar","Existen actividades sin diligenciar en el permiso de trabajo. Por favor diligencie todos para poder continua")
        } 
      }
    })
  }


  continuar(){
    this.buscaActividadesSinDiligenciar()
  }

  navegar(entrada){
    this.router.navigateByUrl(entrada);
 } 

 regresar(){
  this.navegar("/paso4page")
 }
 volveramenu(){
  this.navegar("/menu")
 }



}
